import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "normalize.css";
import "element-ui/lib/theme-chalk/display.css";
import "hover.css";
import "@/assets/css/fonts.css";
import "@/assets/css/style.scss";
// import "@/assets/css/mobile.scss";
import { mobileDetect, responsive } from "@/utils/mobileDetect";

import {
  BackTop,
  Affix,
  Button,
  Menu,
  MenuItem,
  Card,
  Row,
  Col,
  Tag,
  Tabs,
  TabPane,
  Form,
  FormItem,
  Input,
  CheckboxGroup,
  Checkbox,
  Select,
  Option,
  RadioGroup,
  Radio,
  Cascader,
} from "view-design";
import "view-design/dist/styles/iview.css";
Vue.component("Button", Button);
Vue.component("Menu", Menu);
Vue.component("MenuItem", MenuItem);
Vue.component("Card", Card);
Vue.component("Row", Row);
Vue.component("Col", Col);
Vue.component("Tag", Tag);
Vue.component("Tabs", Tabs);
Vue.component("TabPane", TabPane);
Vue.component("Form", Form);
Vue.component("FormItem", FormItem);
Vue.component("Input", Input);
Vue.component("CheckboxGroup", CheckboxGroup);
Vue.component("Checkbox", Checkbox);
Vue.component("Select", Select);
Vue.component("Option", Option);
Vue.component("RadioGroup", RadioGroup);
Vue.component("Radio", Radio);
Vue.component("Cascader", Cascader);
Vue.component("BackTop", BackTop);
Vue.component("Affix", Affix);
Vue.config.productionTip = false;
Vue.use(ElementUI);
router.beforeEach((to, from, next) => {
  if (to.path === from.path) {
    next(false)
  } else {
    next()
  }
})
router.afterEach(() => {
  window.scrollTo(0, 0)
  // 兼容性写法
  document.documentElement.scrollTop = 0
  document.body.scrollTop = 0
})

new Vue({
  router,
  store,
  beforeCreate: () => {
    Vue.prototype.$bus = this;
  },
  created() {
    // 使用更准确的移动端检测
    const platform = mobileDetect.isMobile() ? "mobile" : "web";
    this.$store.dispatch("setPlatform", platform);
    
    // 监听窗口大小变化和设备方向变化
    const removeListener = responsive.addListener(() => {
      const newPlatform = mobileDetect.isMobile() ? "mobile" : "web";
      this.$store.dispatch("setPlatform", newPlatform);
    });
    
    // 组件销毁时清理监听器
    this.$once('hook:beforeDestroy', removeListener);
  },
  render: (h) => h(App),
}).$mount("#app");
